import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import IMTitle from '../../components/typography/IMText';
import IMText from '../../components/typography/IMTitle';
import IMButton from '../../components/common/buttons/IMButton';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { activateNextCard, fetchAllCards, initializeTest, resetQuestions } from '../../store/idealCountrySlice';
import { AppDispatch } from '../../store/store';
import IMPage from '../../components/common/layout/IMPage';
import IMBottomButtonsContainer from '../../components/common/buttons/IMBottomButtonsContainer';
import { resetVisaQuestions } from '../../store/visaProgramSlice';


interface InfoRectProps {
	value: string | number;
	label: string;
}

const InfoRect: React.FC<InfoRectProps> = ({ value, label }) => {
	return (
		<Box
			sx={{
				width: '100%',
				height: '18vw',
				borderRadius: '12px',
				padding: '16px',
				background: '#FFFFFF',
				display: 'flex',
				flexDirection: 'column',
				boxShadow: '0px 4px 15px 0px #0000001F',

			}}
		>
			<IMTitle
				weight="500"
				size="32px"
				color="#212B36"
				props={{ height: '100%', margin: '' }}
			>
				{value}
			</IMTitle>
			<IMText
				weight="500"
				size="14px"
				color="#212B36"
				props={{
					height: '100%',
					display: 'flex',
					justifyContent: 'end',
					flexDirection: 'column',
				}}
			>
				{label}
			</IMText>
		</Box>
	);
};
const InfoRectTiny: React.FC<InfoRectProps> = ({ value, label }) => {
	return (
		<Box
			sx={{
				flex: 1,
				borderRadius: '8px',
				padding: '10px 5px',
				background: '#FFFFFF',
				display: 'flex',
				boxShadow: '0px 4px 15px 0px #0000001F',
				overflow: 'hidden',
				gap: '3px',
				justifyContent: 'center',
				alignItems: 'center'
			}}
		>
			<IMTitle
				weight="500"
				size="15px"
				color="#212B36"
				props={{ margin: '' }}
			>
				{value}
			</IMTitle>
			<IMText
				weight="500"
				size="13px"
				color="#212B36"
				props={{
					whiteSpace: 'nowrap',
				}}
			>
				{label}
			</IMText>
		</Box>
	);
};


const Start = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		dispatch(resetQuestions());
		dispatch(resetVisaQuestions());
		dispatch(fetchAllCards());
	}, []);

	const startTest = async () => {
		await dispatch(initializeTest({}));
		await dispatch(activateNextCard());
		navigate('/questions');
	};

	return (
		<IMPage sx={{ backgroundColor: 'unset', overflow: 'auto' }}>
			<Box
				sx={{
					position: 'relative',
					display: 'flex',
					justifyContent: 'end',
					flexDirection: 'column',
					overflow: 'hidden',
					height: '100dvh',
					flexShrink: 0,
				}}
			>
				<Box
					sx={{
						position: 'absolute',
						height: '100%',
						width: '100%',
						top: 0,
						zIndex: 0,
						background: 'linear-gradient(180deg, #E1F4E4 30%, rgba(255, 255, 255, 0.2) 100%)',
					}}
				>
					<Box
						component={'img'}
						src={`${process.env.PUBLIC_URL}/assets/world.png`}
						alt=""
						sx={{
							width: '100%',
							objectFit: 'cover',
						}}
					/>
				</Box>
				<Box
					sx={{
						width: '100%',
						zIndex: 1,

						paddingBottom: '90px',
					}}
				>
					<Box
						sx={{
							marginBottom: '24px',
							marginX: '12px',
						}}
					>
						<div>
							<IMTitle weight="700" size="32px" color="#212B36">
								Давайте выберем идеальную страну для вас!
							</IMTitle>
							<IMText
								weight="500"
								size="18px"
								color="#212B36"
								opacity={0.7}
								props={{ marginTop: '10px' }}
							>
								Пройдите этот короткий тест и получите рекомендации по эмиграции
							</IMText>
						</div>
					</Box>
					<Box
						sx={{
							marginX: '12px',
							display: 'flex',
							gap: '6px',
							marginBottom: '12px'
						}}
					>
						<InfoRect value={50} label={'Вопросов'}></InfoRect>
						<InfoRect value={10} label={'Категорий'}></InfoRect>
						<InfoRect value={5} label={'Минут на тест'}></InfoRect>
					</Box>
				</Box>
			</Box>

			<IMBottomButtonsContainer>
				<IMButton onClick={startTest}>
					Пройти тест
				</IMButton>
			</IMBottomButtonsContainer>
		</IMPage>
	);
};

export default Start;
